import { render, staticRenderFns } from "./DebugParamsModal.vue?vue&type=template&id=b979abf4"
import script from "./DebugParamsModal.vue?vue&type=script&lang=js"
export * from "./DebugParamsModal.vue?vue&type=script&lang=js"
import style0 from "./DebugParamsModal.vue?vue&type=style&index=0&id=b979abf4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports